import { forwardRef } from "react";
import {
    Dialog, DialogContent, IconButton, Slide, Typography,
} from "@mui/material";
import cx from "classnames";
import CloseIcon from "@mui/icons-material/Close";
import "./BaseDialog.css";

const Transition = forwardRef((props, ref) => (
    <Slide direction="left" ref={ref} {...props} mountOnEnter unmountOnExit />
));

const BaseDialog = (props) => {
    const {
        open,
        onClose,
        withCloseButton,
        title,
        closeOnOutside = true,
        isBig, isWide, isFullSize,
        className,
        children,
    } = props;

    return (
        <Dialog
                className={cx("BaseDialog", { "BaseDialog-big": isBig }, { "BaseDialog-wide": isWide }, { "BaseDialog-fullSize": isFullSize })}
            aria-labelledby="simple-dialog-title"
            TransitionComponent={Transition}
            open={open}
            onClose={closeOnOutside ? onClose : undefined}
            slotProps={{
                paper: { className: cx("BaseDialog__paper", className) },
                backdrop: { className: "BaseDialog__backdrop" },
            }}
        >
            {title || withCloseButton ? (
                <div className="BaseDialog__header">
                    {title && (
                        <Typography component="span" className="BaseDialog__title">
                            {title}
                        </Typography>
                    )}
                    {withCloseButton && (
                        <IconButton aria-label="close" className="BaseDialog__close" onClick={onClose} disableRipple>
                            <CloseIcon />
                        </IconButton>
                    )}
                </div>
            ) : null}
            <DialogContent className="BaseDialog__content">
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default BaseDialog;
